import {
  Component,
  EventEmitter,
  Output,
  QueryList,
  Renderer2,
  SimpleChanges,
  ViewChildren,
} from '@angular/core';
import {
  Input,
  ViewChild,
  ElementRef,
  AfterViewInit,
  OnInit,
  ChangeDetectorRef,
} from '@angular/core';
import { MessageService } from 'primeng/api';
import { ToastType } from '@shared/enum/toast-type';
import {
  Room,
  RoomAmenityList,
} from '@modules/hotel-booking/models/search-available-room.model';
import { formatCurrency } from '@shared/utils/helper';
import { BookedRoomListService } from '@modules/hotel-booking/services/booked-list-rooms.service';
import { ViewDetailsService } from '@modules/hotel-booking/services/view-details.service';
import { ReservationService } from '@modules/hotel-booking/services/reservation-service/reservation.service';
import { TooltipPosition } from '@shared/enum/tooltip.enums';
import { environment } from '@env/environment';
import { SoctripTranslationService } from 'src/app/services/soctrip-translation/soctrip-translation.service';
import { ActivatedRoute } from '@angular/router';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { AmenitiesService } from 'src/app/services/amenities.service';
import { BadgeService } from 'src/app/services/badge.service';

@Component({
  selector: 'app-hotel-page-room-type',
  templateUrl: './hotel-page-room-type.component.html',
  styleUrls: ['./hotel-page-room-type.component.scss'],
  providers: [MessageService],
})
export class HotelPageRoomTypeComponent implements AfterViewInit, OnInit {
  @ViewChild('hotelFacility') hotelFacility: ElementRef;
  @ViewChildren('bedType') bedType: QueryList<ElementRef>;
  @ViewChild('badgeContainer', { static: false }) badgeContainer!: ElementRef;

  @Input() item: any;
  @Input() index: number;
  @Input() checkInDate: string;
  @Output() buyRoomType = new EventEmitter();
  @Output() selectedRoomType = new EventEmitter();

  public displayHotelFacilityList: RoomAmenityList[] = [];
  public slicedItems: string;
  public remaining: number;
  public hasRemaining: boolean;
  is_support_multi_room: boolean;
  baseUrl = environment.BASE_PATH;
  baseImgUrl = environment.STORAGE_SERVICE_API_BASE_PATH_ID_IMAGE;
  tooltip_inclusions: string = '';
  resourceID: number;
  isClickedBook: boolean = false;
  selectedBedType: any = null;
  bedTypeArray: any;
  check_in: string;
  check_out: string;
  userInfo: any;
  currentLanguage: string = '';
  isShowInClusions: boolean = false;
  isShowTooltipNote: boolean = false;
  showLeftArrow: boolean = false;
  showRightArrow: boolean = true;
  isShowRoomUnavailablePopup: boolean = false;

  TooltipPosition: typeof TooltipPosition = TooltipPosition;
  badgeInfo: any;
  displayBadges: any = [];
  isDragging = false;
  startX = 0;
  scrollLeft = 0;

  constructor(
    private messageService: MessageService,
    private renderer: Renderer2,
    private cdRef: ChangeDetectorRef,
    private bookedRoomListService: BookedRoomListService,
    private viewDetailsService: ViewDetailsService,
    private reservationService: ReservationService,
    private soctripTranslationService: SoctripTranslationService,
    private router2: ActivatedRoute,
    private translateService: TranslateService,
    private amenitiesService: AmenitiesService,
    private badgeService: BadgeService,
  ) {
    this.viewDetailsService.getResourceID().subscribe((resourceID: number) => {
      this.resourceID = resourceID;
    });

    const user = JSON.parse(
      localStorage.getItem(environment.USER_PROFILE) || '{}'
    );
    this.userInfo = user;
  }

  ngOnInit(): void {
    console.log('item', this.item);
    
    this.item.room_amenity_list?.filter((item: any) => {
      if (item.amenity_name === 'Spa') {
        item.amenity_icon = 'Spa';
      }
    });
    this.router2.queryParams.subscribe((params) => {
      this.check_in = params['checkin'];
      this.check_out = params['checkout'];
    });

    this.viewDetailsService.getSupportMultiRoom().subscribe((data: boolean) => {
      this.is_support_multi_room = data;
    });

    if (Array.isArray(this.item)) {
      for (let obj of this.item) {
        obj.showTooltipPolicy = false;
        obj.showTooltipTaxes = false;
      }
    }
    if(this.item.badges && this.item.badges.length > 0) {
      const shuffledBadges = this.shuffleArray(this.item.badges || []);
      this.displayBadges = this.getBadgeData(shuffledBadges, this.item.origin_price, this.item.net_price);
      this.translateService.onLangChange.subscribe((event: LangChangeEvent) => {
        this.displayBadges = this.getBadgeData(shuffledBadges);
      });
      console.log(this.displayBadges);
      // this.displayBadges = [this.displayBadges, ... this.displayBadges, ...this.displayBadges]; // Duplicate to fill the space
    }
    
    this.currentLanguage = this.translateService.currentLang;
    this.translateAmenities();
    this.translateRoomView();
    this.translateRoomShower();
    this.translateService.onLangChange.subscribe(() => {
      this.translateAmenities();
      this.translateRoomView();
      this.translateRoomShower();
    });
    if (this.item.bed_types[0]?.bed_type.length === 1) {
      this.selectedBedType = this.item.id;
    }
    this.badgeInfo = this.getReduceAmountBadge(this.item.rate_plan || [])
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['item'] && this.item) {
      this.translateAmenities();
      this.translateRoomView();
      this.translateRoomShower();
      this.badgeInfo = this.getReduceAmountBadge(this.item.rate_plan || [])
    }
  }

  ngAfterViewInit(): void {
    this.cdRef.detectChanges();

//     const el = this.promoContainer?.nativeElement;
//     let isDown = false;
//     let startX: number;
//     let scrollLeft: number;
// 
//     el.addEventListener('mousedown', (e: MouseEvent) => {
//       isDown = true;
//       startX = e.pageX - el.offsetLeft;
//       scrollLeft = el.scrollLeft;
//     });
//     el.addEventListener('mouseleave', () => (isDown = false));
//     el.addEventListener('mouseup', () => (isDown = false));
//     el.addEventListener('mousemove', (e: MouseEvent) => {
//       if (!isDown) return;
//       e.preventDefault();
//       const x = e.pageX - el.offsetLeft;
//       const walk = (x - startX) * 1.5; // scroll speed
//       el.scrollLeft = scrollLeft - walk;
//     });
  }

  translateBadgeName(badge: string): string {
    const key = badge.toLowerCase().replace(/ /g, '_');

    switch (key) {
      case 'top_booked_nearby':
        return 'DETAIL.BADGE.TOP_BOOKED_NEARBY';
      case 'selling_fast':
        return 'DETAIL.BADGE.SELLING_FAST';
      case 'most_popular_hotel_nearby':
        return 'DETAIL.BADGE.MOST_POPULAR_HOTEL_NEARBY';
      case 'highly_rated':
        return 'DETAIL.BADGE.HIGHLY_RATED';
      case 'exclusive_deal':
        return 'DETAIL.BADGE.EXCLUSIVE_DEAL';
      case 'trending_now':
        return 'DETAIL.BADGE.TRENDING_NOW';
      case 'recommended':
        return 'DETAIL.BADGE.RECOMMENDED';
      case 'special_discount':
        return 'DETAIL.BADGE.SPECIAL_DISCOUNT';
      case 'hot_deal':
        return 'DETAIL.BADGE.HOT_DEAL';
      case 'featured':
        return 'DETAIL.BADGE.FEATURED';
      default:
        return 'DETAIL.BADGE.UNKNOWN_BADGE';
    }
  }

  getBadgeStyle(badge: string) {
    switch (badge.toLowerCase()) {
      // Pink
      case 'top booked nearby':
      case 'selling fast':
        return {
          'background-color': '#FFF1F3',
          color: '#F63D68',
          'border-color': '#EAECF0',
          iconUrl: 'assets/icons/Solid__stars-01.svg',
        };
      // Blue 2 star
      case 'most popular hotel nearby':
        return {
          'background-color': '#EFF8FF',
          color: '#2E90FA',
          'border-color': '#B2DDFF',
          iconClass: 'sctr-icon-solid-star-06',
        };
      // Orange 1 star
      case 'highly rated':
        return {
          'background-color': '#FEF6EE',
          color: '#EF6820',
          'border-color': '#F9DBAF',
          iconClass: 'sctr-icon-solid-star-01',
        };
      // Blue 1 star
      case 'exclusive deal':
      case 'trending now':
      case 'recommended':
        return {
          'background-color': '#EFF8FF',
          color: '#2E90FA',
          'border-color': '#B2DDFF',
          iconClass: 'sctr-icon-solid-star-01',
        };
      // Violet
      case 'special discount':
      case 'hot deal':
      case 'featured':
        return {
          'background-color': '#F5F3FF',
          color: '#875BF7',
          'border-color': '#DDD6FE',
          iconClass: 'sctr-icon-solid-tag-01',
        };
      default:
        return {
          'background-color': '#FFF1F3',
          color: '#F63D68',
          'border-color': '#EAECF0',
          iconClass: 'sctr-icon-solid-zap',
        };
    }
  }

  initData = {
    badges: [
      'Top Booked Nearby',
      'Most Popular Hotel Nearby',
      'Highly Rated',
      'Selling Fast',
      'Exclusive Deal',
      'Special discount',
      'Hot Deal',
      'Featured',
      'Trending Now',
      'Recommended',
    ],
  };

  promotions = [
    { image_url: 'assets/images/promotion1.png' },
    { image_url: 'assets/images/promotion2.png' },
    { image_url: 'assets/images/promotion3.png' },
    { image_url: 'assets/images/promotion4.png' },
  ];

  renderTooltipInclusion(inclusions: any): string {
    let tooltip_inclusions = '';
    for (let i = 3; i < inclusions.length; i++) {
      let inclusionKey = '';
      const translatedKey = this.translateInclusions(inclusions[i]);

      if (translatedKey.includes('DETAIL')) {
        inclusionKey = this.translateService.instant(translatedKey);
      } else {
        inclusionKey = translatedKey;
      }

      tooltip_inclusions += `
      <p class="flex items-center gap-1 mt-1 px-[6px] py-[2px] max-w-fit">
        <i class="sctr-icon-check-circle-broken text-[16px] text-palette-emerald-600"></i>
        <span class="font-inter text-xs font-medium text-palette-gray-900 whitespace-nowrap">${inclusionKey}</span>
      </p>
    `;
    }
    return tooltip_inclusions.trim();
  }

  formatPrice(number: number) {
    return formatCurrency(number);
  }

  subtractNumberOfRoom(rate_plan: any, room: any) {
    if (rate_plan.numberRoomBuy > 0) {
      rate_plan.numberRoomBuy--;
      this.bookedRoomListService.setBookedRoomList(
        room.room_type_id,
        'subtract'
      );
      this.buyRoomType.emit(room);
    }

    const totalSelected = room.rate_plan.reduce(
      (sum: number, plan: any) => sum + (plan.numberRoomBuy || 0),
      0
    );
    if (totalSelected < room.num_of_available_rooms) {
      this.isShowRoomUnavailablePopup = false;
    }
  }

  plusNumberOfRoom(rate_plan: any, room: any) {
  const totalSelected = room.rate_plan.reduce(
    (sum: number, plan: any) => sum + (plan.numberRoomBuy || 0),
    0
  );

  if (totalSelected >= room.num_of_available_rooms) {
    this.messageService.add({
      severity: ToastType.WARNING, 
      summary: 'Warning',
      detail: this.translateService.instant('DETAIL.ROOM_UNAVAILABLE'),
    });
    return;
  }

  rate_plan.numberRoomBuy++;
  this.bookedRoomListService.setBookedRoomList(room.room_type_id, 'plus');
  this.buyRoomType.emit(room);
}

  onChooseBedType(room: any) {
    room.selectedBedType = this.selectedBedType.bed_id;
  }

  handleClickRoomHotel(room: any) {
    this.selectedRoomType.emit(room);
  }

  replaceWithDefaultImage(event: any): void {
    event.target.src = 'assets/images/rooms/default_room.png';
  }

  handleClickBookRoom(rate_plan: any, room: any) {
    if (room.bed_types?.length > 1 && !this.selectedBedType) {
      this.messageService.add({
        severity: ToastType.WARNING,
        detail: this.soctripTranslationService.getTranslation(
          'MESSAGE.CHOOSE_BED_TYPE'
        ),
      });
      this.isClickedBook = true;
    } else {
      const data = {
        rate_plan: rate_plan,
        room: room,
        bed_id:
          room.bed_types?.length > 1
            ? this.selectedBedType?.bed_id
            : this.item.bed_types?.[0]?.bed_id,
      };
      this.reservationService.notiBookingSingleRoomType(data);
    }
  }

  getTotalTaxeCharge(taxes: any) {
    if (taxes === null) return 0;

    let totalTaxe = 0;
    for (const value of taxes) {
      if (!value.included_by_supplier) {
        totalTaxe += value.amount;
      }
    }

    return Number(totalTaxe.toFixed(2));
  }

  checkDisplayTaxesAndCharge(rate_plan: any) {
    if (
      rate_plan?.tax_data &&
      rate_plan?.tax_data?.taxes !== null &&
      rate_plan.tax_data.taxes.length > 0 &&
      rate_plan.tax_data.taxes[0].included_by_supplier != true
    ) {
      return true;
    } else {
      return false;
    }
  }

  convertToTitleCase(str: string): string {
    const words = str.split('_');

    const capitalizedWords = words.map((word) => {
      return word.charAt(0).toUpperCase() + word.slice(1);
    });

    const result = capitalizedWords.join(' ');

    return result;
  }

  mouseOverBedType() {
    this.bedTypeArray = this.bedType.toArray();
    this.handleShowTooltip(this.bedTypeArray, 'hotel-bedtype');
  }

  handleShowTooltip(els: ElementRef[], className: string): void {
    for (var val of els) {
      const isTruncated =
        val.nativeElement.scrollWidth > val.nativeElement.clientWidth;
      if (isTruncated) {
        this.renderer.addClass(val.nativeElement, className);
      } else {
        this.renderer.removeClass(val.nativeElement, className);
      }
    }
  }

  calculateDateDifference(checkin: string, checkout: string): number {
    const checkinFormat = new Date(checkin);
    const checkoutFormat = new Date(checkout);

    const checkinTime = checkinFormat.getTime();
    const checkoutTime = checkoutFormat.getTime();

    const differenceInMs = Math.abs(checkoutTime - checkinTime);
    const differenceInDays = Math.ceil(differenceInMs / (1000 * 60 * 60 * 24));

    return differenceInDays;
  }

  isBedAndBreakfast(meal: any) {
    let isBedAndBreakfast = false;
    if (meal.toLowerCase() == 'bed and breakfast') {
      isBedAndBreakfast = true;
    }
    return isBedAndBreakfast;
  }

  formatToTranslateMeal(meal: any) {
    return meal.replace(/[\s-]+/g, '_').toUpperCase();
  }

  renderTextInclusions(rate_plan: any) {
    return `+${rate_plan?.inclusions.length - 1}`;
  }

  convertToTitleCaseInClude(text: string): string {
    if (!text) return '';

    return (
      text.charAt(0).toUpperCase() +
      text.slice(1).toLowerCase().replace(/_/g, ' ')
    );
  }

  translateInclusions(text: string): string {
    if (!text) return '';
    let textTranslate = text;

    switch (text.trim()) {
      case 'Complimentary afternoon tea':
        textTranslate = 'DETAIL.COMPLIMENTARY_AFTERNOON_TEA';
        break;
      case 'Complimentary spa service':
        textTranslate = 'DETAIL.COMPLIMENTARY_SPA_SERVICE';
        break;
      case 'Free upgrade':
        textTranslate = 'DETAIL.FREE_UPGRADE';
        break;
      case 'Pool access':
        textTranslate = 'DETAIL.POOL_ACCESS';
        break;
      case 'Power':
        textTranslate = 'DETAIL.POWER';
        break;
      case 'Round-trip airport transfer':
        textTranslate = 'DETAIL.ROUND_TRIP_AIRPORT_TRANFER';
        break;
      case 'Shuttle bus':
        textTranslate = 'DETAIL.SHUTTLE_BUS';
        break;
      case 'Daily complimentary 2 or 4 bottles of mineral water subject to room category':
        textTranslate = 'DETAIL.DAILY_COMPLIMENTARY';
        break;
      case 'Free use gym machines & outdoor swimming pool':
        textTranslate = 'DETAIL.FREE_GYM_SWIMMING';
        break;
      case 'Others':
        textTranslate = 'DETAIL.OTHERS';
        break;
    }

    return textTranslate;
  }

  uppercaseLetter(text: string) {
    if (text === 'nomeal') {
      return 'NO_MEAL';
    }
    return text.toUpperCase();
  }

  async translateAmenities() {
    if (
      !this.item ||
      !this.item.room_amenity_list ||
      this.item.room_amenity_list.length === 0
    ) {
      return;
    }
    try {
      this.displayHotelFacilityList = (
        await Promise.all(
          this.item.room_amenity_list?.map(
            async (item: { amenity_key: string }) => ({
              ...item,
              amenity_translated: await this.amenitiesService.getValueByKey(
                item.amenity_key,
                this.resourceID
              ),
            })
          )
        )
      ).filter((item) => item.amenity_translated);
      this.item.room_amenity_list = this.displayHotelFacilityList;
    } catch (error) {
      this.displayHotelFacilityList = [];
    }
  }

  async translateRoomView() {
    if (this.item.room_view && this.item.room_view.room_view_name) {
      this.item.room_view.translate_view_name =
        await this.amenitiesService.getValueByKey(
          this.item.room_view?.room_view_name,
          this.resourceID
        );
    }
  }

  async translateRoomShower() {
    if (this.item?.shower && this.item?.shower.shower_name) {
      this.item.shower.translate_shower_name =
        await this.amenitiesService.getValueFromAllResources(
          this.item?.shower.shower_name
        );
    }
  }

  getReduceAmountBadge(ratePlans: any[]): any | null {
    if (!Array.isArray(ratePlans)) return null;

    const itemWithReduceAmount = ratePlans.find(
      item => item.badge_info?.rank_info?.reduce_amount > 0
    );

    return itemWithReduceAmount?.badge_info || null;
  }
  
  showPolicyPopup(ratePlan: any) {
    ratePlan.isShowPolicyPopup = true;
  }

  hidePolicyPopup(ratePlan: any){
    setTimeout(()=>{
      ratePlan.isShowPolicyPopup = false;
    }, 200)
  }

  shuffleArray(array: any[]) {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
  }

  getBadgeData(badgeCodes: string[], originPrice: number = 0, netPrice: number = 0) {
    if (!badgeCodes) return [];

    const styleMap: { [key: string]: any } = {
      'TOP_BOOK_NEARBY': {
        bgColor: '#FFF1F3',
        color: '#F63D68',
        borderColor: '#EAECF0',
        iconUrl: 'assets/icons/Solid__stars-01.svg',
      },
      'SELL_FAST': {
        bgColor: '#FFF1F3',
        color: '#F63D68',
        borderColor: '#EAECF0',
        iconUrl: 'assets/icons/Solid__stars-01.svg',
      },
      'POPULAR_NEARBY': {
        bgColor: '#EFF8FF',
        color: '#2E90FA',
        borderColor: '#B2DDFF',
        iconClass: 'sctr-icon-solid-star-06',
      },
      'HIGH_RATE': {
        bgColor: '#FEF6EE',
        color: '#EF6820',
        borderColor: '#F9DBAF',
        iconClass: 'sctr-icon-solid-star-01',
      },
      'EXCLUSIVE_DEAL': {
        bgColor: '#EFF8FF',
        color: '#2E90FA',
        borderColor: '#B2DDFF',
        iconClass: 'sctr-icon-solid-star-01',
      },
      'TRENDING_NOW': {
        bgColor: '#EFF8FF',
        color: '#2E90FA',
        borderColor: '#B2DDFF',
        iconClass: 'sctr-icon-solid-star-01',
      },
      'RECOMMEND': {
        bgColor: '#EFF8FF',
        color: '#2E90FA',
        borderColor: '#B2DDFF',
        iconClass: 'sctr-icon-solid-star-01',
      },
      'SPECIAL_DISCOUNT': {
        bgColor: '#F5F3FF',
        color: '#875BF7',
        borderColor: '#DDD6FE',
        iconClass: 'sctr-icon-solid-tag-01',
      },
      'HOT_DEAL': {
        bgColor: '#F5F3FF',
        color: '#875BF7',
        borderColor: '#DDD6FE',
        iconClass: 'sctr-icon-solid-tag-01',
      },
      'FEATURE': {
        bgColor: '#F5F3FF',
        color: '#875BF7',
        borderColor: '#DDD6FE',
        iconClass: 'sctr-icon-solid-tag-01',
      },
    };
    
    return badgeCodes.map((badgeCode: any) => {
      const label = this.badgeService.getBadgeLabel(badgeCode, originPrice, netPrice);
      if (!label) return null;
  
      const style = styleMap[badgeCode] || {
        bgColor: '#FFF1F3',
        color: '#F63D68',
        borderColor: '#EAECF0',
        iconClass: 'sctr-icon-solid-zap',
      };
  
      return {
        label,
        badgeCode,
        ...style
      };
    }).filter(Boolean);
  }

  startDrag(event: MouseEvent) {
    this.isDragging = true;
    this.startX = event.pageX - this.badgeContainer.nativeElement.offsetLeft;
    this.scrollLeft = this.badgeContainer.nativeElement.scrollLeft;
  }

  onDrag(event: MouseEvent) {
    if (!this.isDragging) return;
    event.preventDefault();
    const x = event.pageX - this.badgeContainer.nativeElement.offsetLeft;
    const walk = (x - this.startX) * 1; // tốc độ kéo
    this.badgeContainer.nativeElement.scrollLeft = this.scrollLeft - walk;
  }

  stopDrag() {
    this.isDragging = false;
  }
}
